import React, { Component } from 'react';
import { Form, Control,Errors } from "react-redux-form";
import {isRequired, minLength, required} from "../field_validations";
//import Loading from './../loading';
import _ from "lodash";
import {toInt} from "../parsers";

class MunicipalityEditForm extends Component {
	render(){
		const { entities, modalities } = this.props;
		let states = _.map(entities.list);
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="municipalities.edit" onSubmit={(municipality) => this._handleSubmit(municipality)}>
						<div className="field">
							<div className="control">
								<label htmlFor="name" className="label">Nombre <span className="small has-text-danger">*</span></label>
								<Control.text model=".name" id="name" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'Campo Requerido'}}/>
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="state_id" className="label">Estado <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".state_id" id="state_id" className="select" errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Estado ---</option>
										{_.map(states,(state, k) => {
											return <option value={state.id} key={k}>{state.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".state_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El Estado es obligatorio'}} />
							</div>

							<div className="control">
								<label htmlFor="code" className="label">Código <span className="small has-text-danger">*</span></label>
								<Control.text model=".code" id="code" className="input" errors={{isRequired, minLength: minLength(5)}} validateOn="change"/>
								<Errors model=".code" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength: 'Codigo no valido'}} />
							</div>

							{/*<div className="control">
										<label htmlFor="status" className="label">Estatus <span className="small has-text-danger">*</span></label>
										<div className="select">
											<Control.select model=".status_id" id="status" className="select" errors={{required}} validateOn="change">
												<option value="" defaultValue>--- Estatus ---</option>
												{status.data.map((stat, k) => {
													return <option value={stat.id} key={k}>{stat.name}</option>
												})}
											</Control.select>
										</div>
										<Errors model=".status_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El estatus es obligatorio'}} />
									</div>*/}

							<div className="control">
								<label htmlFor="modality_id" className="label">Modalidad <span className="small has-text-danger">*</span></label>
								<div className="select">
									<Control.select model=".modality_id" id="modality_id" parser={ toInt } errors={{required}} validateOn="change">
										<option value=" " defaultValue>--- Modalidad ---</option>
										{_.map(modalities.list,(option, k) => {
											return <option value={option.id} key={k}>{option.name}</option>
										})}
									</Control.select>
								</div>
								<Errors model=".modality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'Debes seleccionar una modalidad.' }} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<div className="message is-primary">
									<div className="message-body">
										<div className="field">
											<div className="control">
												<label htmlFor="accessibility" className="checkbox">
													<Control.checkbox model=".accessibility" id="accessibility" className="checkbox" isToggle={true} />
													<span style={{whiteSpace:'normal'}}> Requiere ayuda visual </span>
												</label>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this.props.history.push('/municipios')}>Regresar</button>
							</div>
							<div className="control">
								<Control.button model="municipalities.edit" className="button is-success" type="submit" disabled={this._validateSave()}>Guardar</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		);
	}

	_handleSubmit(values){
		this.props.municipalitySave(values)
	}

	_validateSave(){
		const {municipalities} = this.props;
		let mc = _.find(municipalities.permissions, (o) => {return o==='Create'});
		let mu = _.find(municipalities.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(municipalities.edit) && municipalities.edit.id){
			if(mu){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(municipalities.edit) && _.isEmpty(municipalities.edit.id)){
			if(mc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}

export default MunicipalityEditForm;


// WEBPACK FOOTER //
// ./src/elements/municipalities/form.jsx